import React from 'react'
import ModalDeactivate from '../../_library/ModalDeactivate'

const BulkInvoiceModals = ({
  // Void Modal Props
  showVoidModal,
  voidInvoice,
  voidReason,
  setVoidReason,
  onVoidCancel,
  onVoidConfirm,
  isVoiding,
  
  // Send Modal Props
  showSendModal,
  sendInvoice,
  onSendCancel,
  onSendConfirm,
  isSending
}) => {
  return (
    <>
      {/* Void Invoice Modal */}
      <ModalDeactivate
        deleting={showVoidModal}
        handleCancelDeactivate={onVoidCancel}
        handleDeactivate={onVoidConfirm}
        isLoading={isVoiding}
        header="Void Invoice"
        content={
          <div>
            <style>{`
              .void-textarea-shared {
                background-color: #2a2a2a !important;
                background: #2a2a2a !important;
                border: 1px solid #444 !important;
                color: #ffffff !important;
                border-radius: 4px !important;
                padding: 8px 12px !important;
                width: 100% !important;
                font-size: 14px !important;
                font-family: inherit !important;
                box-shadow: none !important;
              }
              .void-textarea-shared:focus {
                background-color: #2a2a2a !important;
                background: #2a2a2a !important;
                border-color: #666 !important;
                color: #ffffff !important;
                outline: none !important;
              }
              .void-textarea-shared:disabled {
                background-color: #1a1a1a !important;
                background: #1a1a1a !important;
                color: #888 !important;
              }
            `}</style>
            <p>Are you sure you want to void invoice <strong>{voidInvoice?.invoice_number}</strong>? This action cannot be undone.</p>
            <div className="mt-3">
              <label className="form-label" style={{color: '#ffffff'}}>Reason for voiding (optional):</label>
              <textarea
                className="void-textarea-shared"
                rows={3}
                value={voidReason}
                onChange={(e) => setVoidReason(e.target.value)}
                placeholder="Enter reason for voiding this invoice..."
                disabled={isVoiding}
              />
            </div>
          </div>
        }
        deactivateLabel="Void Invoice"
        deactivateClass="btn-primary"
      />

      {/* Send Invoice Modal */}
      <ModalDeactivate
        deleting={showSendModal}
        handleCancelDeactivate={onSendCancel}
        handleDeactivate={onSendConfirm}
        isLoading={isSending}
        header="Send Invoice"
        content={`Are you sure you want to send invoice ${sendInvoice?.invoice_number}? The invoice will be emailed to the customer.`}
        deactivateLabel="Send Invoice"
        deactivateClass="btn-info"
      />
    </>
  )
}

export default BulkInvoiceModals
